var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightL = function SvgArrowRightL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.04 32.81 16.899-15.49-16.9-15.492",
    stroke: "#fff",
    strokeWidth: 3
  })));
};
export default SvgArrowRightL;